// LA LISTA DE HECHOS, y nada más que pintarla (F4-8).
//
// La pantalla NO compone: cada renglón llega redactado del servidor, que es el
// que va a escribir. Aquí sólo se decide que son renglones y no un párrafo, que
// es justo lo que Juan no podía leer. La misma lista sirve para la vista previa
// y para el recibo: lo único que cambia es el encabezado, que es donde vive el
// tiempo verbal.
//
// VIVE EN SU PROPIO ARCHIVO desde W4'-3b, cuando la usaban dos publicaciones
// distintas y copiarla habría dejado dos maneras de dibujar la misma lista en la
// misma pantalla. Desde W4'-4b la publicación es una sola (el agente entero) y
// la lista se queda aquí: es la forma de "lo que el servidor va a escribir,
// renglón por renglón", y el diálogo de Publicar no es el único lugar donde eso
// se va a pedir.

export interface FactListProps {
  /** Dónde vive el tiempo verbal: "Así va a quedar" / "Así quedó". */
  heading: string
  /** Los renglones, ya redactados por el servidor. */
  facts: string[]
  testId: string
  factTestId: string
}

export function FactList({ heading, facts, testId, factTestId }: FactListProps): JSX.Element {
  return (
    <div data-testid={testId}>
      <p className="text-[12.5px] font-medium text-text">{heading}</p>
      <ul className="mt-1.5 space-y-1">
        {facts.map((fact) => (
          <li
            key={fact}
            data-testid={factTestId}
            className="text-[12.5px] leading-relaxed text-text-2"
          >
            {fact}
          </li>
        ))}
      </ul>
    </div>
  )
}
